<template>
    <el-form label-position="top">

        <el-form-item label="Color">
            <el-color-picker v-model="data.color"></el-color-picker>
        </el-form-item>
    </el-form>
</template>

<style lang="less">
</style>
<script>
    export default {
        props: [
            'data'
        ],
        data () {
            return {};
        },
        watch: {
            'data.color'() {
                $('.cs-color-style').detach();
                $('body').append(
                    $('<style/>', {
                        class: 'cs-color-style',
                        html: `
                        .bg-color {
                            background-color: ${this.data.color} !important;
                        }
                        .bg-color-hover:hover {
                            background-color: ${this.data.color} !important;
                        }
                        .fg-color {
                            color: ${this.data.color} !important;
                        }
                        .fg-color-hover:hover {
                            color: ${this.data.color} !important;
                        }
                        .border-color {
                            border-color: ${this.data.color} !important;
                        }
                        `
                    })
                );
            },
            'data.styles'() {
            }
        }
    }
</script>
